import { takeEvery, put, call, all, fork } from "redux-saga/effects";
import {
  GET_PRODUCT_LIST,
  GET_PRODUCT_UNIT_TYPE_LIST,
  ADD_PRODUCT_UNIT_TYPE,
  UPDATE_PRODUCT_UNIT_TYPE,
  DELETE_PRODUCT_UNIT_TYPE,
  GET_PRODUCT_STOCK_STORAGE_LOCATION_LIST,
  GET_PRODUCT_STOCK_STORAGE_LOCATION_DATA,
  CREATE_PRODUCT_STOCK_STORAGE_LOCATION,
  UPDATE_PRODUCT_STOCK_STORAGE_LOCATION,
  DELETE_PRODUCT_STOCK_STORAGE_LOCATION,
  GET_PRODUCT_STOCK_LIST,
  SEARCH_PRODUCT_STOCK,
  SEARCH_PRODUCT_STOCK_TRANSACTION,
  GET_PRODUCT_STOCK_TRANSACTION_LIST,
  ADD_PRODUCT_STOCK_TRANSACTION,
  MOVE_PRODUCT_STOCK_TRANSACTION,
  REDUCE_PRODUCT_STOCK_TRANSACTION,
  GET_PRODUCT_STOCK_TRANSACTION_REASON_LIST,
  CREATE_PRODUCT_STOCK_TRANSACTION_REASON,
  UPDATE_PRODUCT_STOCK_TRANSACTION_REASON,
  DELETE_PRODUCT_STOCK_TRANSACTION_REASON,
  GET_UNIT_MEASUREMENT_LIST,
} from "./actionType";

import {
  getProductListSuccess,
  getProductListError,
  getProductUnitTypeListSuccess,
  getProductUnitTypeListError,
  addProductUnitTypeSuccess,
  addProductUnitTypeError,
  updateProductUnitTypeSuccess,
  updateProductUnitTypeError,
  deleteProductUnitTypeSuccess,
  deleteProductUnitTypeError,
  getProductStockStorageLocationListSuccess,
  getProductStockStorageLocationListError,
  getProductStockStorageLocationDataSuccess,
  getProductStockStorageLocationDataError,
  createProductStockStorageLocationSuccess,
  createProductStockStorageLocationError,
  updateProductStockStorageLocationSuccess,
  updateProductStockStorageLocationError,
  deleteProductStockStorageLocationSuccess,
  deleteProductStockStorageLocationError,
  getProductStockListSuccess,
  getProductStockListError,
  searchProductStockSuccess,
  searchProductStockError,
  searchProductStockTransactionSuccess,
  searchProductStockTransactionError,
  getProductStockTransactionListSuccess,
  getProductStockTransactionListError,
  addProductStockTransactionSuccess,
  addProductStockTransactionError,
  moveProductStockTransactionSuccess,
  moveProductStockTransactionError,
  reduceProductStockTransactionSuccess,
  reduceProductStockTransactionError,
  getProductStockTransactionReasonListSuccess,
  getProductStockTransactionReasonListError,
  createProductStockTransactionReasonSuccess,
  createProductStockTransactionReasonError,
  updateProductStockTransactionReasonSuccess,
  updateProductStockTransactionReasonError,
  deleteProductStockTransactionReasonSuccess,
  deleteProductStockTransactionReasonError,
  getUnitMeasurementListSuccess,
  getUnitMeasurementListError,
} from "./action";

import {
  getProductList,
  getProductUnitTypesList,
  addProductUnitType,
  updateProductUnitType,
  deleteProductUnitType,
  getProductStockStorageLocationListAPI,
  getProductStockStorageLocationDataAPI,
  createProductStockStorageLocationAPI,
  updateProductStockStorageLocationAPI,
  deleteProductStockStorageLocationAPI,
  getProductStockListAPI,
  searchProductStockAPI,
  searchProductStockTransactionAPI,
  getProductStockTransactionListAPI,
  addProductStockTransactionAPI,
  moveProductStockTransactionAPI,
  reduceProductStockTransactionAPI,
  getProductStockTransactionReasonListAPI,
  createProductStockTransactionReasonAPI,
  updateProductStockTransactionReasonAPI,
  deleteProductStockTransactionReasonAPI,
  getUnitMeasurementListAPI,
} from "../../helpers/fakebackend_helper";

//Saga action

function* getProductListItems() {
  try {
    const response = yield call(getProductList);
    yield put(getProductListSuccess(response));
  } catch (error) {
    yield put(getProductListError(error));
  }
}

export function* watchGetProductList() {
  yield takeEvery(GET_PRODUCT_LIST, getProductListItems);
}

// Get product Unit Types list
function* getProductUnitTypesListItems() {
  try {
    const response = yield call(getProductUnitTypesList);
    yield put(getProductUnitTypeListSuccess(response));
  } catch (error) {
    yield put(getProductUnitTypeListError(error));
  }
}
export function* watchGetProductUnitTypesList() {
  yield takeEvery(GET_PRODUCT_UNIT_TYPE_LIST, getProductUnitTypesListItems);
}

// Add product Unit Type
function* addProductUnitTypeItems({ payload }) {
  try {
    const response = yield call(addProductUnitType, payload);
    yield put(addProductUnitTypeSuccess(response));
  } catch (error) {
    yield put(addProductUnitTypeError(error));
  }
}
export function* watchAddProductUnitType() {
  yield takeEvery(ADD_PRODUCT_UNIT_TYPE, addProductUnitTypeItems);
}

// Update product Unit Type
function* updateProductUnitTypeItems({ payload }) {
  try {
    const response = yield call(updateProductUnitType, payload);
    yield put(updateProductUnitTypeSuccess(response));
  } catch (error) {
    yield put(updateProductUnitTypeError(error));
  }
}
export function* watchUpdateProductUnitType() {
  yield takeEvery(UPDATE_PRODUCT_UNIT_TYPE, updateProductUnitTypeItems);
}

// Delete product Unit Type
function* deleteProductUnitTypeItems({ payload }) {
  try {
    const response = yield call(deleteProductUnitType, payload);
    yield put(deleteProductUnitTypeSuccess(response));
  } catch (error) {
    yield put(deleteProductUnitTypeError(error));
  }
}
export function* watchDeleteProductUnitType() {
  yield takeEvery(DELETE_PRODUCT_UNIT_TYPE, deleteProductUnitTypeItems);
}

// Get product Stock Storage Location List
function* getProductStockStorageLocationListItems() {
  try {
    const response = yield call(getProductStockStorageLocationListAPI);
    yield put(getProductStockStorageLocationListSuccess(response));
  } catch (error) {
    yield put(getProductStockStorageLocationListError(error));
  }
}
export function* watchGetProductStockStorageLocationList() {
  yield takeEvery(
    GET_PRODUCT_STOCK_STORAGE_LOCATION_LIST,
    getProductStockStorageLocationListItems
  );
}

// Get product Stock Storage Location Data
function* getProductStockStorageLocationDataItems({ payload }) {
  try {
    const response = yield call(getProductStockStorageLocationDataAPI, payload);
    yield put(getProductStockStorageLocationDataSuccess(response));
  } catch (error) {
    yield put(getProductStockStorageLocationDataError(error));
  }
}
export function* watchGetProductStockStorageLocationData() {
  yield takeEvery(
    GET_PRODUCT_STOCK_STORAGE_LOCATION_DATA,
    getProductStockStorageLocationDataItems
  );
}

// Create product Stock Storage Location
function* createProductStockStorageLocationItems({ payload }) {
  try {
    const response = yield call(createProductStockStorageLocationAPI, payload);
    yield put(createProductStockStorageLocationSuccess(response));
  } catch (error) {
    yield put(createProductStockStorageLocationError(error));
  }
}
export function* watchCreateProductStockStorageLocation() {
  yield takeEvery(
    CREATE_PRODUCT_STOCK_STORAGE_LOCATION,
    createProductStockStorageLocationItems
  );
}

// Update product Stock Storage Location
function* updateProductStockStorageLocationItems({ payload }) {
  try {
    const response = yield call(updateProductStockStorageLocationAPI, payload);
    yield put(updateProductStockStorageLocationSuccess(response));
  } catch (error) {
    yield put(updateProductStockStorageLocationError(error));
  }
}
export function* watchUpdateProductStockStorageLocation() {
  yield takeEvery(
    UPDATE_PRODUCT_STOCK_STORAGE_LOCATION,
    updateProductStockStorageLocationItems
  );
}

// Delete product Stock Storage Location
function* deleteProductStockStorageLocationItems({ payload }) {
  try {
    const response = yield call(deleteProductStockStorageLocationAPI, payload);
    yield put(deleteProductStockStorageLocationSuccess(response));
  } catch (error) {
    yield put(deleteProductStockStorageLocationError(error));
  }
}
export function* watchDeleteProductStockStorageLocation() {
  yield takeEvery(
    DELETE_PRODUCT_STOCK_STORAGE_LOCATION,
    deleteProductStockStorageLocationItems
  );
}

// Get product Stock List
function* getProductStockListItems() {
  try {
    const response = yield call(getProductStockListAPI);
    yield put(getProductStockListSuccess(response));
  } catch (error) {
    yield put(getProductStockListError(error));
  }
}
export function* watchGetProductStockList() {
  yield takeEvery(GET_PRODUCT_STOCK_LIST, getProductStockListItems);
}

// Search product Stock
function* searchProductStockItems({ payload }) {
  try {
    const response = yield call(searchProductStockAPI, payload);
    yield put(searchProductStockSuccess(response));
  } catch (error) {
    yield put(searchProductStockError(error));
  }
}
export function* watchSearchProductStock() {
  yield takeEvery(SEARCH_PRODUCT_STOCK, searchProductStockItems);
}

// Search product Stock Transaction
function* searchProductStockTransactionItems({ payload }) {
  try {
    const response = yield call(searchProductStockTransactionAPI, payload);
    yield put(searchProductStockTransactionSuccess(response));
  } catch (error) {
    yield put(searchProductStockTransactionError(error));
  }
}

export function* watchSearchProductStockTransaction() {
  yield takeEvery(
    SEARCH_PRODUCT_STOCK_TRANSACTION,
    searchProductStockTransactionItems
  );
}

// Get product Stock Transaction List
function* getProductStockTransactionListItems() {
  try {
    const response = yield call(getProductStockTransactionListAPI);
    yield put(getProductStockTransactionListSuccess(response));
  } catch (error) {
    yield put(getProductStockTransactionListError(error));
  }
}
export function* watchGetProductStockTransactionList() {
  yield takeEvery(
    GET_PRODUCT_STOCK_TRANSACTION_LIST,
    getProductStockTransactionListItems
  );
}

// Add product Stock Transaction
function* addProductStockTransactionItems({ payload }) {
  try {
    const response = yield call(addProductStockTransactionAPI, payload);
    yield put(addProductStockTransactionSuccess(response));
  } catch (error) {
    yield put(addProductStockTransactionError(error));
  }
}
export function* watchAddProductStockTransaction() {
  yield takeEvery(
    ADD_PRODUCT_STOCK_TRANSACTION,
    addProductStockTransactionItems
  );
}

// Move product Stock Transaction
function* moveProductStockTransactionItems({ payload }) {
  try {
    const response = yield call(moveProductStockTransactionAPI, payload);
    yield put(moveProductStockTransactionSuccess(response));
  } catch (error) {
    yield put(moveProductStockTransactionError(error));
  }
}

export function* watchMoveProductStockTransaction() {
  yield takeEvery(
    MOVE_PRODUCT_STOCK_TRANSACTION,
    moveProductStockTransactionItems
  );
}

// Reduce product Stock Transaction
function* reduceProductStockTransactionItems({ payload }) {
  try {
    const response = yield call(reduceProductStockTransactionAPI, payload);
    yield put(reduceProductStockTransactionSuccess(response));
  } catch (error) {
    yield put(reduceProductStockTransactionError(error));
  }
}
export function* watchReduceProductStockTransaction() {
  yield takeEvery(
    REDUCE_PRODUCT_STOCK_TRANSACTION,
    reduceProductStockTransactionItems
  );
}

// Get product Stock Transaction Reason List
function* getProductStockTransactionReasonListItems() {
  try {
    const response = yield call(getProductStockTransactionReasonListAPI);
    yield put(getProductStockTransactionReasonListSuccess(response));
  } catch (error) {
    yield put(getProductStockTransactionReasonListError(error));
  }
}
export function* watchGetProductStockTransactionReasonList() {
  yield takeEvery(
    GET_PRODUCT_STOCK_TRANSACTION_REASON_LIST,
    getProductStockTransactionReasonListItems
  );
}

// Create product Stock Transaction Reason
function* createProductStockTransactionReasonItems({ payload }) {
  try {
    const response = yield call(createProductStockTransactionReasonAPI, payload);
    yield put(createProductStockTransactionReasonSuccess(response));
  } catch (error) {
    yield put(createProductStockTransactionReasonError(error));
  }
}
export function* watchCreateProductStockTransactionReason() {
  yield takeEvery(
    CREATE_PRODUCT_STOCK_TRANSACTION_REASON,
    createProductStockTransactionReasonItems
  );
}

// Update product Stock Transaction Reason
function* updateProductStockTransactionReasonItems({ payload }) {
  try {
    const response = yield call(updateProductStockTransactionReasonAPI, payload);
    yield put(updateProductStockTransactionReasonSuccess(response));
  } catch (error) {
    yield put(updateProductStockTransactionReasonError(error));
  }
}
export function* watchUpdateProductStockTransactionReason() {
  yield takeEvery(
    UPDATE_PRODUCT_STOCK_TRANSACTION_REASON,
    updateProductStockTransactionReasonItems
  );
}

// Delete product Stock Transaction Reason
function* deleteProductStockTransactionReasonItems({ payload }) {
  try {
    const response = yield call(deleteProductStockTransactionReasonAPI, payload);
    yield put(deleteProductStockTransactionReasonSuccess(response));
  } catch (error) {
    yield put(deleteProductStockTransactionReasonError(error));
  }
}
export function* watchDeleteProductStockTransactionReason() {
  yield takeEvery(
    DELETE_PRODUCT_STOCK_TRANSACTION_REASON,
    deleteProductStockTransactionReasonItems
  );
}

// Get Unit Measurement List
function* getUnitMeasurementListItems() {
  try {
    const response = yield call(getUnitMeasurementListAPI);
    yield put(getUnitMeasurementListSuccess(response));
  } catch (error) {
    yield put(getUnitMeasurementListError(error));
  }
}
export function* watchGetUnitMeasurementList() {
  yield takeEvery(GET_UNIT_MEASUREMENT_LIST, getUnitMeasurementListItems);
}

// Main Saga Function
function* ProductSagaCrmIT() {
  yield all([
    fork(watchGetProductList),
    fork(watchGetProductUnitTypesList),
    fork(watchAddProductUnitType),
    fork(watchUpdateProductUnitType),
    fork(watchDeleteProductUnitType),
    fork(watchGetProductStockStorageLocationList),
    fork(watchGetProductStockStorageLocationData),
    fork(watchCreateProductStockStorageLocation),
    fork(watchUpdateProductStockStorageLocation),
    fork(watchDeleteProductStockStorageLocation),
    fork(watchGetProductStockList),
    fork(watchSearchProductStock),
    fork(watchSearchProductStockTransaction),
    fork(watchGetProductStockTransactionList),
    fork(watchAddProductStockTransaction),
    fork(watchMoveProductStockTransaction),
    fork(watchReduceProductStockTransaction),
    fork(watchGetProductStockTransactionReasonList),
    fork(watchCreateProductStockTransactionReason),
    fork(watchUpdateProductStockTransactionReason),
    fork(watchDeleteProductStockTransactionReason),
    fork(watchGetUnitMeasurementList),
  ]);
}

export default ProductSagaCrmIT;
